import { eventsTable } from '@/controllers/events-table'
import { pineapple } from '@/controllers/events'

const [route, action] = ['pineapple', 'get-check-address-messages']

export const getPineappleCheckAddressMessages = function (callback) {
  window[Symbol.for('vue.prototype')].$sendMessageToWorker({ route, action })

  eventsTable[pineapple[action]] = callback
}
